export const apiUrl = "https://api.spot-map.com"; // live
// export const apiUrl = "https://7l60bxbl-4069.inc1.devtunnels.ms"; // live

export const s3Url = "https://kastrati.s3.eu-west-3.amazonaws.com";
export const imageUrl = (url) => {
  const result = url?.indexOf("http");
  const imageRenderUrl = result == -1 ? `${s3Url}/${url}` : url;
  return imageRenderUrl;
};
export const mediaUrl = (url) => `${s3Url}/${url}`;

export const BaseURL = (link) => {
  return `${apiUrl}/api/v1/${link}`;
};
